import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Logo } from '../components/Logo';

export const LoginPage: React.FC = () => {
  const { user, signInWithGoogle, loading } = useAuth();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  const fromLocation = (location.state as any)?.from;
  const from = fromLocation
    ? fromLocation.pathname + (fromLocation.search || '')
    : '/dashboard';

  const handleGoogleSignIn = async () => {
    try {
      setError(null);
      await signInWithGoogle();
    } catch (err: any) {
      setError(err.message || 'Failed to sign in');
    }
  };

  if (user) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <Logo size="lg" className="justify-center" />
        </div>

        {/* Card */}
        <div className="bg-card rounded-lg border border-border shadow-sm p-8">
          <h1 className="text-xl font-semibold text-center text-foreground mb-1">
            Welcome back
          </h1>
          <p className="text-sm text-center text-muted-foreground mb-6">
            Sign in with your Wifirst account to continue
          </p>

          {error && (
            <div className="p-3 mb-4 text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950/30 rounded border border-red-200 dark:border-red-900">
              {error}
            </div>
          )}

          <Button
            onClick={handleGoogleSignIn}
            disabled={loading}
            className="w-full bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 text-white"
            size="lg"
          >
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            {loading ? 'Signing in...' : 'Sign in with Google'}
          </Button>

          <p className="text-xs text-center text-muted-foreground mt-4">
            Only @wifirst.fr accounts are allowed
          </p>
        </div>

        {/* Copyright */}
        <p className="text-center mt-6 text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} SecDesk &mdash; Powered by Wifirst
        </p>
      </div>
    </div>
  );
};
